module.exports = __webpack_public_path__ + "static/media/campainha.f07cca19.mp3";